module.exports = __webpack_public_path__ + "static/media/b-sci-major-1_LR.2c3d8fd7.jpg";